import { useContext } from 'react';

import { DatadogRumContext } from './Context';
import type { ContextType } from './types';

export const useDatadogRum = () => {
  const context = useContext(DatadogRumContext);

  if (!context) {
    throw new Error(
      'useDatadogRum must be called from within DatadogRumProvider',
    );
  }

  return context as ContextType;
};
